import React from "react";
import {
  TableCell,
  TextField,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Button,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";
import BookedEventsModel from "../../models/BookedEvents";
import PaymentTypes from "../../models/PaymentTypes";
import { DatePicker } from "@mui/x-date-pickers";
import { Temporal } from "@js-temporal/polyfill";
import Constants from "../../models/Constants";

const PayedAndBookedEvents = (props: any) => {
  const columnNames: string[] = [
    "Veranstaltung",
    "Buchungsdatum",
    "Veranstaltungsdatum",
    "Anmeldungen",
    "Preis",
    "Zahlungsart",
    "Bezahlt",
    "Aktionen",
  ];

  let tableColumns = columnNames.map((x) => {
    return <TableCell key={x}>{x}</TableCell>;
  });

  let rows = (props.events as BookedEventsModel[]).map((x) => {
    return (
      <TableRow key={x.booking.id}>
        <TableCell>{x.event.eventName}</TableCell>
        <TableCell>
          {Temporal.Instant.from(new Date(x.booking.bookingDate).toISOString())
            .toZonedDateTimeISO("UTC") // or another timezone
            .toPlainDate()
            .toString()
            .split("-")
            .reverse()
            .join(".")}
        </TableCell>

        <TableCell>
          {`${Temporal.Instant.from(new Date(x.event.eventFrom).toISOString())
            .toZonedDateTimeISO("UTC")
            .toPlainDate()
            .toString()
            .split("-")
            .reverse()
            .join(".")} - ${Temporal.Instant.from(new Date(x.event.eventTo).toISOString())
            .toZonedDateTimeISO("UTC")
            .toPlainDate()
            .toString()
            .split("-")
            .reverse()
            .join(".")}`}
        </TableCell>
        <TableCell>{x.numberMembers}</TableCell>
        <TableCell>{`€ ${
          typeof x.booking.bookingTotal != "undefined" && x.booking.bookingTotal
            ? x.booking.bookingTotal.toFixed(2).replace(".", ",")
            : "0,-"
        }`}</TableCell>
        <TableCell>{x.paymentType.paymentTypeName}</TableCell>
        <TableCell>{x.booking.paymentStatusName}</TableCell>
        <TableCell>
          {/*<Button className='btnBlue' color='primary' variant='contained'>
                    Details
    </Button>*/}
        </TableCell>
      </TableRow>
    );
  });

  let paymentTypes = (props.paymentTypes as PaymentTypes[]).map((x) => {
    return (
      <MenuItem key={x.id} value={x.id}>
        {x.paymentTypeName}
      </MenuItem>
    );
  });

  return (
    <>
      <div className="card">
        <div className="card-header">
          <h5>Filters</h5>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-sm-5">
              <TextField
                label="Veranstaltung:"
                name="eventName"
                value={props.filter.eventName}
                onChange={(e: any) => props.filterChange(e)}
                fullWidth
              ></TextField>
            </div>
            <div className="col-sm-5 offset-sm-1">
              <DatePicker
                label="Beginndatum von:"
                value={new Date(props.filter.bookingDateFrom)}
                format={Constants.DateFormat}
                onChange={(date: any) => {
                  let event = {
                    target: {
                      name: "bookingDateFrom",
                      value: date,
                    },
                  };
                  props.filterChange(event);
                }}
                
              />
            </div>
          </div>
          <div className="row mt-sm-3">
            <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 order-sm-2 offset-sm-1">
              <DatePicker
                label="Beginndatum bis:"
                value={new Date(props.filter.bookingDateTo)}
                format={Constants.DateFormat}
                onChange={(date: any) => {
                  let event = {
                    target: {
                      name: "bookingDateTo",
                      value: date,
                    },
                  };
                  props.filterChange(event);
                }}
                
              />
            </div>
            <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 order-sm-1 mt-2 mt-sm-0 ">
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-aktiv">Zahlungsart:</InputLabel>
                <Select
                  input={<OutlinedInput id="outlined-aktiv" fullWidth />}
                  fullWidth
                  name="paymentTypeId"
                  onChange={(e: any) => props.filterChange(e)}
                  value={
                    typeof props.filter.paymentTypeId != "undefined"
                      ? props.filter.paymentTypeId
                      : ""
                  }
                >
                  <MenuItem value="">
                    <em></em>
                  </MenuItem>
                  {paymentTypes}
                </Select>
              </FormControl>
            </div>
          </div>
          <div className="float-right mt-4">
            <Button
              variant="contained"
              color="primary"
              className="btnBlue"
              onClick={() => props.handleFilter()}
            >
              Suchen
            </Button>
            <Button
              className="ml-2 btnBlue"
              color="primary"
              variant="contained"
              onClick={() => props.clearFilters()}
            >
              Zurücksetzen
            </Button>
          </div>
        </div>
      </div>
      <div
        className="row mt-3"
        style={{ overflowX: "auto", overflowY: "hidden" }}
      >
        <Table className="objects-table table">
          <TableHead>
            <TableRow>{tableColumns}</TableRow>
          </TableHead>
          <TableBody>{rows}</TableBody>
        </Table>
      </div>
    </>
  );
};

export default PayedAndBookedEvents;
